import styled from "styled-components";
import { MainSlide } from "../../components/MainSlide";
import { FancyButton } from "./components/button";
import { useTraduzioniQuery } from "../../generated/graphql";

const VerticalLine = styled.div`
  position: absolute;
  background-color: #a2a087;
  bottom: -50px;
  right: 100px;

  width: 2px;
  height: 100%;
  opacity: 0.5;
`;
const HorizontalLine = styled.div`
  position: absolute;
  background-color: #a2a087;
  bottom: 50px;
  right: 30px;
  width: 70%;
  height: 2px;
  opacity: 0.5;
`;
const Container = styled(MainSlide)`
  background-position: bottom;
  max-height: 600px;
  position: relative;
  @media screen and (max-width: 900px) {
    ${VerticalLine} {
      display: none;
    }
    ${HorizontalLine} {
      display: none;
    }
  }
`;

const ButtonPrenota = styled(FancyButton)`
  position: absolute;
  bottom: 80px;
  left: 20%;

  @media screen and (max-width: 900px) {
    bottom: 10%;
    left: 50%;
    transform: translate(-50%, -50%); /* pull back by half its own size */
  }
`;
const Logo = styled.div`
  background-image: url("/kum/logo.webp");
  position: absolute;
  bottom: 0;
  right: 130px;
  width: 200px;
  height: 150px;
  background-repeat: no-repeat;
  background-size: contain;
  @media screen and (max-width: 900px) {
    bottom: 0%;
    left: 50%;
    transform: translate(-50%, -50%); /* pull back by half its own size */
  }
`;

export function CoverRestaurant(props: { book: () => void }) {
  const { data } = useTraduzioniQuery();
  return (
    <>
      <Container $url="bgkun.webp">
        <VerticalLine />
        <HorizontalLine />
        <ButtonPrenota onClick={props.book}>
          {data?.traduzioniVarie?.prenota}
        </ButtonPrenota>
        <Logo></Logo>
      </Container>
    </>
  );
}
